import { Routes } from '@angular/router';
import { authGuard, createAuthCallbackRoute, createLoggedOutRoute } from '@presencelearning/auth';
import { AboutComponent } from './about/about.component';
import { HomeComponent } from './home/home.component';

export const routes: Routes = [
  createAuthCallbackRoute(),
  createLoggedOutRoute(),
  { path: '', component: HomeComponent, canActivate: [authGuard] },
  { path: 'about', component: AboutComponent, canActivate: [authGuard] },
];
